/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@mantine/core';
import { IMAGE_MIME_TYPE } from '@mantine/dropzone';
import AppStack from './AppStack';
import FileUpload from './FileUpload';
import { fileToBase64String } from '../../helpers/awsHelper';
import { triggerNotification } from '../../helpers/notificationHelper';

const CustomerFileInput = ({
  label,
  description,
  onChange,
  required,
  value,
  disabled
}) => {
  const [imagePreview, setImagePreview] = useState(null);

  return (
    <AppStack style={{ gap: 5 }}>
      <TextInput
        description={description}
        label={label}
        styles={{ input: { display: 'none' } }}
        withAsterisk={required}
      />

      <FileUpload
        accept={IMAGE_MIME_TYPE}
        disabled={disabled}
        height={100}
        imagePreview={imagePreview || value}
        onError={(e) => {
          triggerNotification(e);
        }}
        onRemove={() => {
          onChange(null);
          setImagePreview(null);
        }}
        onUpload={(files) => {
          onChange(files[0], 'file');
          fileToBase64String(files[0], setImagePreview);
        }}
        value={value}
        variant="image"
      />
    </AppStack>
  );
};

CustomerFileInput.propTypes = {
  description: PropTypes.string,
  disabled: PropTypes.bool,
  isStoreAdminViewing: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  pkEcomStore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  required: PropTypes.bool,
  value: PropTypes.string
};

export default CustomerFileInput;
